
document.addEventListener('DOMContentLoaded', function () {

    if (window.jQuery) {
        (function ($, sitenav) {
            "use strict";
            sitenav = sitenav || (window.sitenav = {});
            sitenav.App = sitenav.App || (sitenav.App = {});

            sitenav.App.Social = {
                setProfilePic: function () {

                    var profilePicUrl = $("#ProfilePictureUrl").val();

                    if (profilePicUrl && profilePicUrl !== "") {

                        $.ajax({
                            type: "GET",
                            url: profilePicUrl + "?width=40&height=40&redirect=false"
                        })
                            .done(function (data) {
                                if (!data.data.is_silhouette) {

                                    if (data.data.url != "") {
                                        var header = $("#profilePicHeader");
                                        header.empty();
                                        header.addClass("profilePicture");
                                        header.append('<img src="' + data.data.url + '" />My Profile');
                                    }
                                }
                            });
                    }
                },

                setNavProfilePic: function () {
                    var profilePicUrl = $("#ProfilePictureUrl").val(),
                        navLink = $("#profilePicNavLink"),
                        defaultProfileIcon = '<i class="icon-member">&nbsp;</i>';

                    if (profilePicUrl && profilePicUrl != "") {

                        $.ajax({
                            type: "GET",
                            url: profilePicUrl + "?width=40&height=40&redirect=false"
                        })
                            .done(function (data) {
                                if (!data.data.is_silhouette) {
                                    if (data.data.url != "") {
                                        navLink.prepend('<img class="navProfilePicture" src="' + data.data.url + '" />');
                                        $(".nav-membership").addClass("wide");
                                    }
                                } else {
                                    navLink.prepend(defaultProfileIcon);
                                    $("#MemberCentreName").addClass("member-name");
                                }
                            });
                    } else {
                        navLink.prepend(defaultProfileIcon);
                        $("#MemberCentreName").addClass("member-name");
                    }
                }
            };

            sitenav.App.Social.setNavProfilePic();
        }(jQuery, window.sitenav));
    }
});